import {
  MEMBER_SUMMARY_LOADING,
  MEMBER_SUMMARY_SUCCESS,
  MEMBER_SUMMARY_FAILED,
  PENSION_LOADING,
  PENSION_SUCCESS,
  PENSION_FAILED
} from '../actions/memberSummaryActions'

const memberSummary = (state = {}, action) => {
  switch (action.type) {
    case MEMBER_SUMMARY_LOADING:
      return Object.assign({}, state, {
        isLoading: true,
        error: null,
        memberSummary: null
      })
    case MEMBER_SUMMARY_SUCCESS:
      return Object.assign({}, state, {
        memberSummary: action.response,
        error: null,
        isLoading: false
      })
    case MEMBER_SUMMARY_FAILED:
      return Object.assign({}, state, {
        memberSummary: null,
        error: action.error,
        isLoading: false
      })
    case PENSION_LOADING:
      return Object.assign({}, state, {
        pensionIsLoading: true,
        error: null,
        pension: null
      })
    case PENSION_SUCCESS:
      return Object.assign({}, state, {
        pension: action.response,
        error: null,
        pensionIsLoading: false
      })
    case PENSION_FAILED:
      return Object.assign({}, state, {
        pension: null,
        error: action.error,
        pensionIsLoading: false
      })
    default:
      return state
  }
}
export default memberSummary



// WEBPACK FOOTER //
// ./src/redux/reducers/memberSummaryReducer.js